import { DataModel } from '@shared';

export interface SurroundingIntervalsModel {
	previousInterval: DataModel;
	nextInterval: DataModel;
}
